"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStripePayment = void 0;
var react_1 = require("react");
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var axios_1 = __importDefault(require("axios"));
var useStripePayment = function (_a) {
    var clientSecret = _a.clientSecret, onPaymentProcess = _a.onPaymentProcess, onBeforeFormSubmit = _a.onBeforeFormSubmit;
    var stripe = react_stripe_js_1.useStripe();
    var elements = react_stripe_js_1.useElements();
    var _b = react_1.useState({ status: "invalid" }), card = _b[0], setCard = _b[1];
    var _c = react_1.useState({ status: "initial" }), payment = _c[0], setPayment = _c[1];
    var _d = react_1.useState(""), errorMessage = _d[0], setErrorMessage = _d[1];
    var handleCardElementChange = function (e) {
        var cardValid = e.complete;
        setCard({
            status: cardValid ? "valid" : "invalid",
        });
    };
    var handleFormSubmission = function (billing_details) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, error;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setErrorMessage("");
                    if (!clientSecret)
                        throw Error("No client secret supplied.");
                    if (!(typeof onPaymentProcess === "function")) return [3 /*break*/, 2];
                    return [4 /*yield*/, onPaymentProcess()];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    setPayment({ status: "processing" });
                    if (!stripe) {
                        throw Error("Stripe instance could not be found");
                    }
                    if (!elements) {
                        throw Error("Card form instance could not be found");
                    }
                    if (!(typeof onBeforeFormSubmit === "function")) return [3 /*break*/, 6];
                    _e.label = 3;
                case 3:
                    _e.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, onBeforeFormSubmit()];
                case 4:
                    _e.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _e.sent();
                    setPayment({ status: "error" });
                    setErrorMessage(axios_1.default.isAxiosError(error_1)
                        ? (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data.message
                        : (_c = (_b = error_1) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "An unknown error occurred");
                    return [2 /*return*/];
                case 6: return [4 /*yield*/, stripe.confirmPayment({
                        elements: elements,
                        confirmParams: billing_details
                            ? {
                                payment_method_data: {
                                    billing_details: billing_details,
                                },
                            }
                            : undefined,
                        redirect: "if_required",
                    })];
                case 7:
                    error = (_e.sent()).error;
                    if (error) {
                        setPayment({ status: "error", stripeException: error });
                        setErrorMessage((_d = error.message) !== null && _d !== void 0 ? _d : "An unknown error occurred");
                    }
                    else {
                        setPayment({ status: "succeeded" });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        handleFormSubmission: handleFormSubmission,
        handleElementChange: handleCardElementChange,
        card: card,
        payment: payment,
        errorMessage: errorMessage,
    };
};
exports.useStripePayment = useStripePayment;
